export * from './lib/theme-generator.module';
export { ThemeGeneratorService } from './lib/theme-generator.service';
